<template>
  <div class="bom-sync-erp-config-form">
    <Form label-position="top">
      <FormItem :label="$t('bom_tool.migration.select_version')" v-if="bomRevisions">
        <Select v-model="selectedVersion" @on-change="handleVersionChanged" style="width: 200px;">
          <Option v-for="revision in bomRevisions" :value="revision.version" :key="revision.version"></Option>
        </Select>
      </FormItem>
      <FormItem>
        <span class="warning" v-if="bomList.length > 0">Found BOMs: {{ bomList.length }}</span>
        <vxe-table
          ref="bomSyncTable"
          :data="bomList"
          :loading="runningProsecutor || runningSyncProcess"
          :checkbox-config="{ checkMethod: checkboxStateMethod, showHeader: false }"
          @checkbox-change="handleSelectChange"
          size="mini"
          border
          resizable>
          <vxe-table-column type="checkbox" width="40" align="center"></vxe-table-column>
          <vxe-table-column field="manufacturer_part.part_identity.part_number" :title="$t('bom_tool.migration.part_number')" width="140"></vxe-table-column>
          <vxe-table-column field="name" :title="$t('bom_tool.migration.name')" min-width="300"></vxe-table-column>
          <vxe-table-column field="version" :title="$t('bom_tool.migration.version')" width="100"></vxe-table-column>
          <!-- <vxe-table-column field="note" title="Message" min-width="340"></vxe-table-column> -->
          <vxe-table-column :title="$t('bom_tool.migration.erp_state')" width="300">
            <template v-slot="{ row }">
              <span v-if="loadingStatus && loadingStatus[row.id]">loading</span>
              <span v-else-if="prosecutorResult && prosecutorResult[row.id]">{{ $t(`bom_tool.prosecutor_code_message.${prosecutorResult[row.id]['erp_bom_state_checker'][0]['code']}`) }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('bom_tool.migration.sync_state')" width="300">
            <template v-slot="{ row }">
              <span v-if="migrationStatus && migrationStatus[row.id]">loading</span>
              <p v-else-if="migrateResult && migrateResult[row.id]" :data-id="row.id">{{ migrateResult[row.id]['results']['bom_main'][row.id]['ProductID'] }}</p>
            </template>
          </vxe-table-column>
        </vxe-table>
      </FormItem>
      <FormItem v-if="!wrappedInModal">
        <Button type="warning" @click="doMigration" :loading="runningSyncProcess">
        {{ $t('bom_tool.migration.start_migration') }}
        </Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BOMSync2ERPConfigForm',
  props: {
    wrappedInModal: Boolean,
    currentBom: Object
  },
  data () {
    return {
      selectedVersion: null,
      bomRevisions: [],
      bomList: [],
      runningProsecutor: false,
      runningSyncProcess: false,
      prosecutorResult: [],
      prosecutorCheckers: [
        'integrity_checker',
        'part_number_checker',
        'erp_bom_state_checker'
      ],
      loadingStatus: {},
      migrationStatus: {},
      selected: [],
      migrateResult: {}
    }
  },
  methods: {
    ...mapActions([
      'getBomVersions',
      'loadBomVersionTree',
      'runBOMProsecutorChecks',
      'migrateBomToErp'
    ]),
    async doMigration () {
      // migration all can be synchronized.
      let sortedBOMs = this.selected.reduce((holder, val) => {
        let index = val.parent_bom_id ? _.findIndex(holder, { id: val.parent_bom_id }) : holder.length - 1
        holder.splice(index, val.parent_bom_id ? -1 : 0, val)
        return holder
      }, [])

      for (const bom of sortedBOMs) {
        this.migrationStatus[bom.id] = true
        this.$refs.bomSyncTable.refreshColumn()
        this.runningSyncProcess = true
        this.$emit('update:running', this.runningSyncProcess)
        await this.migrateBomToErp({ bom_id: bom.id, bom_version: bom.version, 'duplicate': true }).then(respData => {
          this.migrateResult[bom.id] = respData
        }).finally(() => {
          this.migrationStatus[bom.id] = false
          this.runningSyncProcess = false
          this.$emit('update:running', this.runningSyncProcess)
          this.$refs.bomSyncTable.refreshColumn()
        })
      }
    },
    handleVersionChanged () {
      if (this.selectedVersion) {
        this.migrateResult = {}
        this.prosecutorResult = {} // reset
        this.$refs.bomSyncTable.refreshColumn()
        this.loadBomVersionTree({ bomId: this.currentBom.id, version: this.selectedVersion }).then((resp) => {
          this.bomList = resp.data
        })
      }
    },
    flattenBomTree (currentBom, holder = []) {
      holder.push(_.omit(currentBom, ['children']))
      if (currentBom.children && currentBom.children.length > 0) {
        currentBom.children.forEach((child) => {
          // Giving a parent_bom_id that we can check dependencies before creating.
          child.parent_bom_id = currentBom.id
          holder = this.flattenBomTree(child, holder)
        })
      }
      return holder || []
    },
    runBOMProsecutor () {
      if (this.bomList) {
        this.runningProsecutor = true
        this.bomList.forEach((it) => {
          this.loadingStatus[it.id] = true
          this.runBOMProsecutorChecks({
            bomId: it.id,
            version: it.version,
            partNumber: it.manufacturer_part?.part_identity.part_number,
            checkers: this.prosecutorCheckers
          }).then(resp => {
            this.prosecutorResult = Object.assign({}, this.prosecutorResult, { [it.id]: resp.data })
          }).finally(() => {
            this.runningProsecutor = false
            this.loadingStatus[it.id] = false
            this.$refs.bomSyncTable.refreshColumn()
          })
        })
      }
    },
    checkboxStateMethod ({ row }) {
      return this.prosecutorResult[row.id] &&
        this.prosecutorResult[row.id]['erp_bom_state_checker'][0]['code'] !== 'ERP_BOM_VERSION_FOUND' &&
        (!this.migrateResult[row.id] || !this.migrateResult[row.id]['success'])
    },
    handleSelectChange ({ checked, records }) {
      this.selected = records
    }
  },
  mounted () {
    this.getBomVersions({ id: this.currentBom.id }).then(resp => {
      this.bomRevisions = resp.data
    })
  },
  watch: {
    bomList: {
      deep: true,
      handler () {
        this.runBOMProsecutor()
      }
    }
  }
}
</script>
